import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import styles from "../Home/Dashboard.module.css";
import { motion } from "framer-motion";
import { UseTickerTistData } from "../Utils/AllData";
// import CustomSlider from "../components/custom-slider";
import LoadingSpinner from "../components/loading-spinner";
import Moment from "moment";
import ApprovedTick from "../assets/ApprovedTick.svg";
import PendingTick from "../assets/Pending.svg";
import { ChevronDownIcon, ChevronUpIcon, MinusCircle } from "lucide-react";
// import PnlValue from "./PnlValue";
// import LoadingSpinnerNew from "../components/LoadingSpinner2";
import CandleChart from "../components/candle-chart";
import { toast } from "sonner";

const style = {
  selectDiv:
    "flex items-center px-2 py-2 text-[14px] rounded-lg mx-3 md-3 text-neutral-300 hover:bg-[#000000]/80 hover:text-white/85 ease-linear duration-150 cursor-pointer",
  mainDiv: "mt-10 flex flex-col md:flex-row md:items-center ",
  labelText: "w-full md:w-[25%] text-[#ffffff] font-poppins",
  inputDiv:
    "mt-4 md:mt-0 md:ml-32 flex flex-row items-center border-b border-[#ffffff]/20 pb-2",
  inputBox:
    "w-[300px] md:w-[500px] pl-4 bg-transparent text-[#ffffff]/80 font-poppins ",
  inputBox2:
    "w-[300px] md:w-[200px] pl-4 bg-transparent text-[#ffffff]/80 font-poppins z-20",
  tableData: "text-[14px] text-white font-poppins py-4 px-2 min-w-[120px]",
  selectDiv1:
    "flex items-center px-2 py-2 text-[14px] text-[#E43D3D] border-b border-[#ffffff]/20 hover:rounded-md mx-3 md-3 text-neutral-300 hover:bg-[#818CED]/10 hover:border-[#818CED]/10 ease-linear duration-150 cursor-pointer",
  selectDiv2:
    "flex items-center px-2 py-2 text-[14px] text-[#18b13f] hover:rounded-md mx-3 md-3 hover:bg-[#818CED]/10 hover:border-[#818CED]/10 ease-linear duration-150 cursor-pointer",
  selectDiv3:
    "flex items-center px-2 py-2 border-b border-[#ffffff]/20 text-[14px] text-[#D7BD34] hover:rounded-md mx-3 md-3 text-neutral-300 hover:bg-[#818CED]/10 hover:border-[#818CED]/10 ease-linear duration-150 cursor-pointer",
  hideScrollbar: "overflow-x-auto scrollbar-hide",
  whiteInputBox:
    "w-[300px] md:w-[500px] pl-4 bg-white text-black font-poppins rounded-md",
  whiteSelectDiv:
    "flex items-center px-2 py-2 text-[14px] rounded-lg mx-3 md-3 text-black bg-white hover:bg-gray-200 ease-linear duration-150 cursor-pointer",
  whiteInputBoxSmall:
    "w-[150px] pl-4 bg-white text-black font-poppins rounded-md",
  inputBoxSmall:
    "w-[150px] pl-4 bg-transparent text-[#ffffff]/80 font-poppins z-20",
};

const globalStyles = `
  .scrollbar-hide::-webkit-scrollbar { display: none; }
  .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
`;

const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = globalStyles;
document.head.appendChild(styleSheet);

const TickerBuySell = () => {
  const { data: allTickers } = UseTickerTistData();
  const saved = localStorage.getItem("userDetails");
  const initialValue = JSON.parse(saved);
  const userDetails = initialValue && initialValue.response;
  const tickerListData = allTickers && allTickers.data.values;
  const currentDate = new Date();
  const [tickerPrice, setTickerPrice] = useState(null);
  const newDate = Moment(String(currentDate)).format("MM/DD/YYYY");
  const [tickerList, setTickerList] = useState("");
  const [chartTickerList, setChartTickerList] = useState("QUICKUSDT");
  const [position, setPosition] = useState("");
  const [sliderValue, setSliderValue] = useState(
    tickerPrice === null ? 0 : tickerPrice?.low
  );
  const [tickerQuantity, setTickerQuantity] = useState("");
  // const [showPosition, setShowPosition] = useState(false);
  // const [showFirstDropdown, setShowFirstDropdown] = useState(false);
  const [showSecondDropdown, setShowSecondDropdown] = useState(false);
  const [showIntervalDropdown, setShowIntervalDropdown] = useState(false);
  const [showDurationDropdown, setShowDurationDropdown] = useState(false);
  const [showComponent, setShowComponent] = useState(false);
  const [error, setError] = useState(false);
  const [errorShow, setErrorShow] = useState(false);
  // const [showMsg, setShowMsg] = useState("");
  // const [buyValue, setBuyValue] = useState("");
  const [showButtonText, setShowButtonText] = useState(false);
  // const [searchTermFirst, setSearchTermFirst] = useState("");
  const [searchTermSecond, setSearchTermSecond] = useState("");
  const [selectedInterval, setSelectedInterval] = useState("1h");
  const [selectedDuration, setSelectedDuration] = useState("5d");
  const chartSectionRef = useRef(null);
  // const [sellLoader, setSellLoader] = useState(false);
  // const [sellState, setSellState] = useState(false);

  const intervals = ["1h", "2h", "4h"];
  const durations = ["1d", "2d", "3d", "4d", "5d"];

  const generateRandomString = () => {
    const length = 10;
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  console.log("Error",error);
  console.log("showbutton text",showButtonText)
  console.log("tickerQuantity",tickerQuantity)
  console.log("sliderValue",sliderValue)
  console.log("position",position);
  console.log("tickerList",tickerList)

  // const handleTradeSell = (data) => {
  //   setSellLoader(true);
  //   axios
  //     .post(
  //       "https://server.anshfintech.com/api/admin/history/complete/closed-trade",
  //       {
  //         date: newDate,
  //         sell_value: data.close,
  //         sell_quantity: data.quantity,
  //         tradeId: data.tradeId,
  //         email: userDetails && userDetails[1],
  //         buy_value: data.buy_value,
  //       }
  //     )
  //     .then((res) => {
  //       setSellLoader(false);
  //       toast.success("You have successfully placed your sell order");
  //       getAllLiveTrade();
  //       setSellState(true);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setSellLoader(false);
  //     });
  // };

  const handleSubmit = async (data) => {

    console.log("calling development submit function Data form chart is",data);

    const tradeId = generateRandomString();
    setShowButtonText(true);
    if (
      !chartTickerList ||
      !data.quantity ||
      !data.buy_value ||
      !data.sell_value
    ) {
      setErrorShow(true);
      setError("All Fields are required");
      setShowButtonText(false);
      return;
    } else {
  
      console.log("Complete Data form chart is",data)

      const new_pnl_value_data = await getPnlValue(data.buy_value,chartTickerList,data.quantity);

      console.log("Latest Pnl values are",  new_pnl_value_data)
      const new_pnl_value = new_pnl_value_data.pnlValue;
      const new_pnl_percent = new_pnl_value_data.pnlPercent;

      axios
        .post("https://server.anshfintech.com/api/admin/live/live-trade", {
          date: newDate,
          symbol: chartTickerList,
          position: data.position,
          buy_value: data.buy_value,
          sell_value: data.sell_value,
          quantity: data.quantity,
          pnlValue: new_pnl_value,
          pnlPercent:new_pnl_percent,
          status: "", // Default to Approved since Pending is removed
          tradeId: tradeId,
          email: userDetails && userDetails[1],
          buy_date:data.buy_date,
          sell_date:data.sell_date,
        })
        .then((res) => {
          setShowComponent(true);
          toast.success("You have successfully placed your order");
          setShowButtonText(false);
          getAllLiveTrade();
      
        })
        .catch((err) => {
          console.log(err);
          setShowButtonText(false);
        });
    }
  };

  useEffect(() => {
    if (showComponent) {
      setShowComponent(true);
      const toRef = setTimeout(() => {
        setShowComponent(false);
        setPosition("");
        setTickerQuantity("");
        clearTimeout(toRef);
      }, 4000);
    }
  }, [showComponent]);

  useEffect(() => {
    if (errorShow) {
      setErrorShow(true);
      const toRef = setTimeout(() => {
        setErrorShow(false);
        clearTimeout(toRef);
      }, 2000);
    }
  }, [errorShow]);

  // const [loading, setLoading] = useState(false);

  // const handleFirstTickerSelection = (ticker) => {
  //   setShowFirstDropdown(false);
  //   setTickerList(ticker);
  //   getTickerPrice(ticker);
  // };

  const handleSecondTickerSelection = (ticker) => {
    setShowSecondDropdown(false);
    setChartTickerList(ticker);
    setTickerList("");
    setPosition("");
    setTickerQuantity("");
  };

  const handleIntervalSelection = (interval) => {
    setSelectedInterval(interval);
    setShowIntervalDropdown(false);
  };

  const handleDurationSelection = (duration) => {
    setSelectedDuration(duration);
    setShowDurationDropdown(false);
  };

  const getTickerPrice = (ticker) => {
    // setLoading(true);
    let data = JSON.stringify({ ticker: ticker });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://server.anshfintech.com/api/admin/ticker/ticker-data",
      headers: { "Content-Type": "application/json" },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        setTickerPrice(response.data.data);
        // setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        // setLoading(false);
      });
  };

  const price = getTickerPrice();
  console.log("Price",price)



  // const handleSearchChangeFirst = (e) => setSearchTermFirst(e.target.value);
  const handleSearchChangeSecond = (e) => setSearchTermSecond(e.target.value);

  const [allTrade, setAllTrade] = useState();
  const [allTradeLoading, setAllTradeLoading] = useState(true);
  const getAllLiveTrade = async () => {
    await axios
      .get("https://server.anshfintech.com/api/common/live/live-trade")
      .then((res) => {
        setAllTrade(res.data);
        setAllTradeLoading(false);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getAllLiveTrade();
  }, []);

  const [showTradeStatus, setShowTradeStatus] = useState([]);
  const [loadingStates, setLoadingStates] = useState(
    Array(allTrade && allTrade.length).fill(false)
  );

  const toggleTradeStatus = (index) => {
    const newShowTradeStatus = [...showTradeStatus];
    newShowTradeStatus[index] = !newShowTradeStatus[index];
    setShowTradeStatus(newShowTradeStatus);
  };

  const handleTradeStatus = (i, status) => {
    setLoadingStates((prevStates) => {
      const newLoadingStates = [...prevStates];
      newLoadingStates[i] = true;
      return newLoadingStates;
    });
    axios
      .post(
        "https://server.anshfintech.com/api/admin/live/approve/live-trade-status",
        {
          status: status,
          tradeId: allTrade && allTrade[i][8],
          email: userDetails && userDetails[1],
        }
      )
      .then((res) => {
        setShowTradeStatus(new Array(allTrade.length).fill(false));
        setLoadingStates((prevStates) => {
          const newLoadingStates = [...prevStates];
          newLoadingStates[i] = false;
          return newLoadingStates;
        });
        getAllLiveTrade();
      })
      .catch((err) => console.log(err));
  };

  const handleDeleteTrade = (tradeId, index) => {
    axios
      .post("https://server.anshfintech.com/api/admin/live/delete-trade", {
        tradeId: tradeId,
      })
      .then((res) => {
        getAllLiveTrade();
        toast.success("Trade Deleted Successfully");
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (tickerPrice !== null) {
      setSliderValue(tickerPrice.price);
    }
  }, [tickerPrice]);

  const [pnlValues, setPnlValues] = useState([]);

  useEffect(() => {
    if (allTrade && allTrade.length > 0) {
      const fetchPnlValues = async () => {
        const promises = allTrade.map(async (dataItem) => {
          const pnlValue = await getPnlValue(
            dataItem[3],
            dataItem[1],
            dataItem[4]
          );
          return pnlValue;
        });
        const results = await Promise.all(promises);
        setPnlValues(results);
      };
      fetchPnlValues();
    }
  }, [allTrade]);

  const getPnlValue = async (buy_value, ticker, quantity) => {
    let data = JSON.stringify({ ticker: ticker });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://server.anshfintech.com/api/admin/ticker/ticker-data",
      headers: { "Content-Type": "application/json" },
      data: data,
    };

    return axios
      .request(config)
      .then((response) => {
        const tickerPrice = response.data.data.price;
        console.log("the ticker price data response", response.data.data);
        const pnlValue = (tickerPrice - buy_value) * quantity;
      const pnlPercent = ((tickerPrice - buy_value) / buy_value) * 100;
        return {
          pnlValue: pnlValue.toFixed(2),
          pnlPercent: pnlPercent.toFixed(2),
        };
      })
      .catch((error) => {
        console.log(error);
        return { pnlValue: 0, pnlPercent: 0 };
      });
  };

  return (
    <div className="flex pt-16 md:pt-12 px-3 md:px-12 min-h-screen ">
      <div className="relative w-full pt-10 pb-2 md:pt-12 md:pb-4 lg:pt-16 lg:pb-8">
        <div className="absolute -top-[450px] -left-[200px] z-0 blur-box w-[460px] h-[560px] md:w-[760px] md:h-[760px] rounded-full filter blur-2xl opacity-90 "></div>

        <div className="mt-0 ">
          <div className={`xl:absolute top-[70px] flex gap-4 items-center justify-start  flex-wrap`}>
            <div className={`z-10 relative  cursor-pointer`}>
              <div className={`${styles.inputLabel} text-[#D9D9D9]/70`}>Ticker list</div>
              <div
                onClick={() => setShowSecondDropdown(!showSecondDropdown)}
                className={`${style.inputBox} w-full border border-[#ffffff]/10 mt-2 px-3 py-2 rounded-[8px] bg-[#1a1a1a] flex justify-between`}
              >
                {chartTickerList ? (
                  <div className={styles.dropDownSelection}>
                    {chartTickerList}
                  </div>
                ) : (
                  <div className={styles.dropDownSelection}>
                    Select your Ticker
                  </div>
                )}
                <div
                  className={`pl-2 ease-linear duration-150 text-white cursor-pointer z-0`}
                >
                  {showSecondDropdown ? (
                    <ChevronUpIcon size={20} color="#fff" />
                  ) : (
                    <ChevronDownIcon size={20} color="#fff" />
                  )}
                </div>
              </div>
              {showSecondDropdown && (
                <motion.div
                  initial={{ y: -50, opacity: 0 }}
                  animate={{ y: 20, opacity: 1 }}
                  transition={{ duration: 0.5, type: "spring" }}
                  exit={{ y: -50, opacity: 0 }}
                  className={`absolute right-0 top-12 bg-[#14141D] flex flex-col w-[100%] pt-2 pb-2 z-10 ${styles.dropdownBox2}`}
                >
                  <div className="px-3 w-full">
                    <input
                      type="text"
                      placeholder="Search ticker..."
                      value={searchTermSecond}
                      onChange={handleSearchChangeSecond}
                      className="p-2 bg-[#1f1f2e] text-white w-full rounded-sm"
                    />
                  </div>
                  {tickerListData &&
                    tickerListData
                      .filter((ele) =>
                        ele[0]
                          .toLowerCase()
                          .includes(searchTermSecond.toLowerCase())
                      )
                      .map((ele, i) => (
                        <div
                          className={`${style.selectDiv} pl-3 font-medium`}
                          onClick={() => handleSecondTickerSelection(ele[1])}
                          key={i}
                        >
                          {ele[0]}
                        </div>
                      ))}
                </motion.div>
              )}
            </div>
            <div className="ml-4">
              <div className={`${styles.inputLabel} text-[#D9D9D9]/70`}>Interval</div>
              <div
                onClick={() => setShowIntervalDropdown(!showIntervalDropdown)}
                className={`${style.inputBoxSmall}  w-full border border-[#ffffff]/10 mt-2 px-3 py-2 rounded-[8px] bg-[#1a1a1a] flex justify-between`}
              >
                <div className={styles.dropDownSelection}>
                  {selectedInterval}
                </div>
                <div
                  className={`pl-2 ease-linear duration-150 text-white cursor-pointer`}
                >
                  {showIntervalDropdown ? (
                    <ChevronUpIcon size={20} color="#fff" />
                  ) : (
                    <ChevronDownIcon size={20} color="#fff" />
                  )}
                </div>
              </div>
              {showIntervalDropdown && (
                <motion.div
                  initial={{ y: -50, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.5, type: "spring" }}
                  exit={{ y: -50, opacity: 0 }}
                  className={`absolute bg-[#14141D] flex flex-col w-[150px] pt-2 pb-2 z-10 ${styles.dropdownBox2}`}
                >
                  {intervals.map((interval, i) => (
                    <div
                      className={`${style.selectDiv} pl-3 font-medium`}
                      onClick={() => handleIntervalSelection(interval)}
                      key={i}
                    >
                      {interval}
                    </div>
                  ))}
                </motion.div>
              )}
            </div>
            <div className="ml-4">
              <div className={`${styles.inputLabel} text-[#D9D9D9]/70`}>Duration</div>
              <div
                onClick={() => setShowDurationDropdown(!showDurationDropdown)}
                className={`${style.inputBoxSmall} w-full border border-[#ffffff]/10 mt-2 px-3 py-2 rounded-[8px] bg-[#1a1a1a] flex justify-between`}
              >
                <div className={styles.dropDownSelection}>
                  {selectedDuration}
                </div>
                <div
                  className={`pl-2 ease-linear duration-150 text-white cursor-pointer`}
                >
                  {showDurationDropdown ? (
                    <ChevronUpIcon size={20} color="#fff" />
                  ) : (
                    <ChevronDownIcon size={20} color="#fff" />
                  )}
                </div>
              </div>
              {showDurationDropdown && (
                <motion.div
                  initial={{ y: -50, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.5, type: "spring" }}
                  exit={{ y: -50, opacity: 0 }}
                  className={`absolute bg-[#14141D] flex flex-col w-[150px] pt-2 pb-2 z-10 ${styles.dropdownBox2}`}
                >
                  {durations.map((duration, i) => (
                    <div
                      className={`${style.selectDiv} pl-3 font-medium`}
                      onClick={() => handleDurationSelection(duration)}
                      key={i}
                    >
                      {duration}
                    </div>
                  ))}
                </motion.div>
              )}
            </div>
          </div>
          
          <div ref={chartSectionRef} className="overflow-hidden ">
            <CandleChart
              handleSubmit={handleSubmit}
              symbol={chartTickerList}
              interval={selectedInterval}
              duration={selectedDuration}
            />
          </div>
        </div>

        <div className="mt-10 text-3xl text-white font-semibold font-montserrat">
          All Live Trade
        </div>
        {!allTrade && !allTrade ? (
          <div className="mt-10 w-full custom-scroll overflow-x-auto  animate-reveal transition-all duration-200 ease-in shadow-custom-inner backdrop-blur-custom bg-black">
            <table className="text-sm w-full relative z-0">
              <thead className="text-sm text-left border-b-[1px] border-[#818CEE]/20 shadow-custom-inner backdrop-blur-custom bg-black">
                <tr className="text-white">
                  <th className="py-6 text-left pl-4 text-[14px] font-medium rounded-tl-lg">
                    DATE
                  </th>
                  <th className="py-6 text-left px-2 text-[14px] font-medium">
                    SYMBOL
                  </th>
                  <th className="py-6 text-left px-2 text-[14px] font-medium">
                    POSITION
                  </th>
                  <th className="py-6 text-left px-2 text-[14px] font-medium">
                    BUY VALUE
                  </th>
                  <th className="py-6 text-left px-2 text-[14px] font-medium">
                    SELL VALUE
                  </th>
                  <th className="py-6 text-left px-2 text-[14px] font-medium">
                    QUANTITY
                  </th>
                  <th className="py-6 text-left px-2 text-[14px] font-medium">
                    PNL VALUE
                  </th>
                  <th className="py-6 text-left px-2 text-[14px] font-medium">
                    PNL(in%)
                  </th>
                  <th className="py-6 text-right px-2 pr-6 text-[14px] font-medium">
                    STATUS
                  </th>
                  <th className="py-6 text-right px-2 pr-6 text-[14px] font-medium">
                    ACTION
                  </th>
                </tr>
              </thead>
            </table>
            <span className="w-full text-white text-2xl md:text-4xl flex flex-row justify-center py-16">
              {allTradeLoading === true ? (
                <LoadingSpinner />
              ) : (
                "No Data Available"
              )}
            </span>
          </div>
        ) : (
          <div
            className={`mt-6 w-full custom-scroll ${style.hideScrollbar} shadow-md animate-reveal transition-all duration-200 ease-in`}
          >
            <table className="text-sm w-full relative z-0">
              <thead className="text-sm text-left border-b-[1px] border-[#818CEE]/20 shadow-custom-inner backdrop-blur-custom bg-black">
                <tr className="text-[#ffffff]/60">
                  <th className="py-6 text-left pl-4 text-[14px] font-medium rounded-tl-lg">
                    DATE
                  </th>
                  <th className="py-6 text-left px-2 text-[14px] font-medium">
                    SYMBOL
                  </th>
                  <th className="py-6 text-left px-2 text-[14px] font-medium">
                    POSITION
                  </th>
                  <th className="py-6 text-left px-2 text-[14px] font-medium">
                    BUY VALUE
                  </th>
                  <th className="py-6 text-left px-2 text-[14px] font-medium">
                    SELL VALUE
                  </th>
                  <th className="py-6 text-left px-2 text-[14px] font-medium">
                    QUANTITY
                  </th>
                  <th className="text-left py-6 px-2 text-[14px] font-medium">
                    PNL VALUE
                  </th>
                  <th className=" py-6 text-left px-2 text-[14px] font-medium">
                    PNL(%)
                  </th>
                  <th className="py-6 text-right px-2 pr-6 text-[14px] font-medium">
                    STATUS
                  </th>
                  <th className="py-6 text-right px-2 pr-6 text-[14px] font-medium">
                    ACTION
                  </th>
                </tr>
              </thead>
              <tbody className="shadow-custom-inner backdrop-blur-custom bg-black">
                {allTrade &&
                  allTrade
                    .sort((a, b) => new Date(b[0]) - new Date(a[0]))
                    .map((dataItem, i) => (
                      <tr key={i} className="z-0 border-b border-[#818CEE]/20">
                        <td className={`${style.tableData} pl-4`}>
                          {Moment(String(dataItem[0])).format("DD-MM-YYYY")}
                        </td>
                        <td className={style.tableData}>{dataItem[1]}</td>
                        <td className={style.tableData}>{dataItem[2]}</td>
                        <td className={style.tableData}>{dataItem[3]}</td>
                        <td className={style.tableData}>{dataItem[11]}</td> {/* Added sell_value */}
                        <td className={style.tableData}>{dataItem[4]}</td>
                        <td
                          className={`text-left ${style.tableData} ${
                            pnlValues[i]?.pnlValue > 0
                              ? `text-[#18b13f]`
                              : pnlValues[i]?.pnlValue < 0
                              ? `text-[#eb323f]`
                              : `text-[#f2f2f2]`
                          }`}
                        >
                          {pnlValues[i]?.pnlValue}
                        </td>
                        <td
                          className={`text-center ${style.tableData} ${
                            pnlValues[i]?.pnlPercent > 0
                              ? `text-[#18b13f]`
                              : pnlValues[i]?.pnlPercent < 0
                              ? `text-[#eb323f]`
                              : `text-[#f2f2f2]`
                          }`}
                        >
                          {pnlValues[i]?.pnlPercent}%
                        </td>
                        <td className={`${style.tableData} items-center`}>
                          <span className="relative">
                            {loadingStates[i] ? (
                              <span className="flex flex-row justify-center">
                                <svg
                                  className="h-6 w-6 text-[#E43D3D] animate-spin"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  ></circle>
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                  ></path>
                                </svg>
                              </span>
                            ) : dataItem[7] === "Approved" ? (
                              <span className="text-[#18b13f] flex flex-row justify-center items-center">
                                <img
                                  src={ApprovedTick}
                                  alt="Approved Tick"
                                  className="mr-2"
                                />
                                {dataItem[7]}
                              </span>
                            ) : dataItem[7] === "Declined" ? (
                              <span className="text-[#E43D3D] flex flex-row justify-center items-centerr">
                                <MinusCircle className="mr-2 h-5" />
                                {dataItem[7]}
                              </span>
                            ) : (
                              <span className="">
                                <span
                                  onClick={() => toggleTradeStatus(i)}
                                  className={`flex flex-row justify-center text-[#D7BD34] pb-2 cursor-pointer items-center`}
                                >
                                  <span className="flex">
                                    <img
                                      src={PendingTick}
                                      alt="Pending Tick"
                                      className="mr-2"
                                    />
                                    Select Status
                                  </span>
                                  <span
                                    className={`pl-2 ease-linear duration-150 text-white cursor-pointer`}
                                  >
                                    {showTradeStatus[i] ? (
                                      <ChevronUpIcon className="w-5 h-5 text-white/50" />
                                    ) : (
                                      <ChevronDownIcon className="w-5 h-5 text-white/50" />
                                    )}
                                  </span>
                                </span>
                                {showTradeStatus[i] && (
                                  <motion.span
                                    initial={{ y: -50, opacity: 0 }}
                                    animate={{ y: 0, opacity: 1 }}
                                    transition={{
                                      duration: 0.5,
                                      type: "spring",
                                    }}
                                    exit={{ y: -50, opacity: 0 }}
                                    className={`absolute right-0 top-8 bg-[#14141d] rounded-lg flex flex-col w-[100%] pt-2 pb-2 z-50`}
                                  >
                                    {/* <span
                                      className={`${style.selectDiv3} pl-3 font-medium`}
                                      onClick={() =>
                                        handleTradeStatus(i, "Pending")
                                      }
                                    >
                                      <img
                                        src={PendingTick}
                                        alt="Pending Tick"
                                        className="mr-2"
                                      />
                                      Pending
                                    </span> */}
                                    <span
                                      className={`${style.selectDiv1} pl-3 font-medium`}
                                      onClick={() =>
                                        handleTradeStatus(i, "Declined")
                                      }
                                    >
                                      <MinusCircle className="mr-2 w-4 h-4" />
                                      Declined
                                    </span>
                                    <span
                                      className={`text-[#18b13f] ${style.selectDiv2} pl-3 font-medium`}
                                      onClick={() =>
                                        handleTradeStatus(i, "Approved")
                                      }
                                    >
                                      <img
                                        src={ApprovedTick}
                                        alt="Approved Tick"
                                        className="mr-2"
                                      />
                                      Approved
                                    </span>
                                  </motion.span>
                                )}
                              </span>
                            )}
                          </span>
                        </td>
                        <td className={`text-right ${style.tableData} pr-6`}>
                          {dataItem[7] === "Approved" ? (
                            // <span
                            //   className="bg-[#E43D3D] text-white font-semibold px-3 py-1 rounded-[6px] cursor-pointer"
                            //   onClick={() =>
                            //     handleSellTicker(
                            //       dataItem[1],
                            //       dataItem[2],
                            //       dataItem[4],
                            //       dataItem[8],
                            //       dataItem[3]
                            //     )
                            //   }
                            // >
                            //   CLOSE
                            // </span>
                            <span
                              className="bg-[#E43D3D] text-white font-semibold px-3 py-1 rounded-[6px] cursor-pointer"
                              onClick={() => handleDeleteTrade(dataItem[8], i)}
                            >
                              DELETE
                            </span>
                          ) : (
                            <span
                              className="bg-[#E43D3D] text-white font-semibold px-3 py-1 rounded-[6px] cursor-pointer"
                              onClick={() => handleDeleteTrade(dataItem[8], i)}
                            >
                              DELETE
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default TickerBuySell;